import React, { JSX } from 'react';
import Button from '@mui/material/Button';
import { LzTThemeColor } from '@lz/app/Theming/types';
import { LzTButonSizes } from '@lz/typings';

import './Button.scss';

export interface LzPButton {
  children?: React.ReactNode;
  text?: string;
  icon?: JSX.Element;
  primary?: boolean;
  secondary?: boolean;
  success?: boolean;
  error?: boolean;
  info?: boolean;
  warning?: boolean;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  size?: LzTButonSizes;
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const LzXButton = (props: LzPButton) => {
  let color: 'inherit' | LzTThemeColor | undefined = 'inherit';
  if (props.primary) {
    color = 'primary';
  }
  if (props.secondary) {
    color = 'secondary';
  }
  if (props.success) {
    color = 'success';
  }
  if (props.error) {
    color = 'error';
  }
  if (props.info) {
    color = 'info';
  }
  if (props.warning) {
    color = 'warning';
  }

  const styles: any = props.style || {};

  return (
    <Button
      color={color}
      variant={props.variant || 'contained'}
      size={props.size}
      disabled={props.disabled}
      className={'lz-button ' + (props.className || '')}
      style={styles}
      onClick={props.onClick}
    >
      {props.children || props.text}
    </Button>
  );
};

export default LzXButton;
